import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { TableButton } from '../../TableButton';

import ColumnResize from "react-table-column-resizer";

export class ProviderLanesDraftList extends Component {
    static contextTypes = {
        edition: PropTypes.object
    }

    sortLanes(a, b) {
        let aName = a.name;
        let bName = b.name;

        if ("object" === typeof aName) {
            aName = undefined !== aName.left ? aName.left : aName.right;
        }

        if ("object" === typeof bName) {
            bName = undefined !== bName.left ? bName.left : bName.right;
        }

        return aName !== bName ? aName < bName ? -1 : 1 : 0;
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    render() {
        const { lanes = [], isLoading, currentPage, elementsPerPage, filter } = this.props;
        const lanesFiltered = SearchHelper.search({
            filter: filter,
            data: lanes,
            fields: ["name"]
        });

        const totalPages = PaginationHelper.getTotalPages(lanesFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const lanesToRender = lanesFiltered.sort((a, b) => this.sortLanes(a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        const LaneTypeNames = {
            2: "Estacionamento",
            // Add more as needed
        };
        
        function renderLaneTypeName(type) {
            return LaneTypeNames[type] || "Unknown";
        }

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <ColumnResize className="columnResizer" />
                                <th>Descrição</th>
                                <ColumnResize className="columnResizer" />
                                <th>Tipo</th>
                                <ColumnResize className="columnResizer" />
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {lanesToRender.map((lane, idx) =>
                                    <tr key={`lane-${idx}`}>
                                        <td>{lane.name}</td>
                                        <td className="column_resizer_body" />
                                        <td>{lane.description}</td>
                                        <td className="column_resizer_body" />
                                        <td>{renderLaneTypeName(lane.type)}</td>
                                        <td className="column_resizer_body" />
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(lane)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(lane)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={activePage}
                        elementsPerPage={elementsPerPage}
                        dataLength={lanesFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)}
                    />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}